import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

import { RouterOutlet } from '@angular/router';
import { LangService } from './shared/service/lang.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet],
})
export class AppComponent {
  private langService = inject(LangService);
  private title = inject(Title);

  // Need to instantiate the LangService in at least one component.
  // This has to be done as early as possible, so translations are loaded
  constructor() {
    if (environment.projectName) {
      this.title.setTitle(environment.projectName);
    }
  }
}
